import React, {Component} from 'react';
import RedirectOnlyHome from "../common/RedirectOnlyHome";

class SuccessPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	render() {
		return (<>
			<RedirectOnlyHome />
			<div className={'col text-center'} style={{padding: "20px 30px", marginBottom: "25px"}}>
				<h3 style={{color:"#d63545"}}>Your booking has been successfully submitted,<br/>soon you’ll be going with the Gecko!</h3>
				<div>
					<br/><br/>
					Thank you for your completing your reservation. A copy of your Tax Invoice has been forwarded to your nominated email address.
					<br/><br/>
					Once your Reservation has been approved, we will send you confirmation, along with your Booking Number. You will need your booking number and nominated email address to access your booking via the Book N Go App. Access to your booking and vehicle location - is allowed on the day of the booking (2 hours prior to the booking start time).
				</div>
				<div>
					<br/><br/>
					<strong>Have a nice day!</strong><br/>
					<em>Go With The Gecko Team</em>
				</div>
			</div>
		</>);
	}
}

export default SuccessPage;